import * as _ from 'underscore';

import { ContentLineageRelationshipInfo } from '../models/ContentLineageRelationshipInfo';
import { ContentLineageRelationship } from '../ServerApi/types/ContentLineageRelationship';

export module ContentLineageRelationshipMapper {

export function map(
  contentLineageRelationships: ReadonlyArray<ContentLineageRelationship>): ContentLineageRelationshipInfo[] {
    return _.map(contentLineageRelationships, (r: ContentLineageRelationship) => {
      return {
        content: { id: r.contentId, name: r.contentName },
        contentType: r.contentType,
        relatedContent: r.relatedContent,
        lineageRelationshipType: r.lineageRelationshipType,
        userHasRunPermissions: r.userHasRunPermissions,
        linkedTasksAreNotEnabled: r.linkedTasksAreNotEnabled,
      };
    });
  }
}
